import script from "./UpcomingBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingBookings.vue?vue&type=script&setup=true&lang=js"

import "./UpcomingBookings.vue?vue&type=style&index=0&id=09bf135d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09bf135d"]])

export default __exports__